import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000/api",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("ROCP_idToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token.replaceAll('"', "")}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      toast.error("Session expired. Please login again.");
      window.location.assign("/logout");
      return;
    }
    toast.error(error.response?.data?.message || "API error");
    return Promise.reject(error);
  }
);

export default axiosInstance;
